import React from "react";
import { Autocomplete, TextField, Box } from "@mui/material";

interface OptionType {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface BorgStylePickerProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  errorText?: string;
  options: OptionType[];
}

const colorBorgOrange = "rgb(255, 182, 61)";
const colorBorgBlue = "rgb(87,236,243)";
const colorError = "red";

export const BorgStylePicker: React.FC<BorgStylePickerProps> = ({
  id,
  label,
  value,
  onChange,
  required,
  errorText,
  options,
}) => {
  // find the selected option object
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        mb: 2,
        pl: "14px",
        borderLeft: `3px solid ${errorText ? colorError : colorBorgOrange}`,
      }}
    >
      <Autocomplete
        value={selectedOption}
        onChange={(_, newValue) => onChange(newValue?.value || "")}
        options={options}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, val) => option.value === val.value}
        fullWidth
        renderOption={(props, option) => (
          <li {...props}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {option.icon}
              {option.label}
            </Box>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="standard"
            required={required}
            error={!!errorText}
            helperText={errorText}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              startAdornment: selectedOption?.icon ? (
                <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                  {selectedOption.icon}
                </Box>
              ) : null,
            }}
            sx={{
              "& .MuiInputLabel-root": { color: "rgb(118, 69, 26)" },
              "& .MuiInputBase-root": { color: colorBorgOrange },
            }}
          />
        )}
        ListboxProps={{
          sx: {
            bgcolor: "#2c2c2c",
            color: colorBorgOrange,
            "& .MuiAutocomplete-option.Mui-selected": { backgroundColor: "#3a3a3a" },
            "& .MuiAutocomplete-option:hover": { backgroundColor: "#3a3a3a" },
            "& .MuiAutocomplete-option": { color: colorBorgOrange },
          },
        }}
      />
    </Box>
  );
};
